import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastService, ToastType } from '../../services/toast.service';
import { ResetPasswordService } from '../../services/resetPassword.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent {

  userId: String;
  resetCode: String;
  constructor(
    private router: Router,
    private resetPassword: ResetPasswordService,
    private toastService: ToastService,
    private route: ActivatedRoute,

  ) { }

  hide = true;
  rehide = true;
  form: FormGroup = new FormGroup({
    password: new FormControl('', [Validators.required]),
    repassword: new FormControl('', [Validators.required])
  });
  submitted = false;
  isLoader = false;
  isVerified = false;
  isTokenMissing = false;
  isPasswordMismatch = false;
  registeredCompanyAppUserId: string;
  historyState: any;

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {

        this.userId = params.userId;
        this.resetCode = params.resetCode;

      }
      );

  }

  onSubmit(): void {
    this.submitted = true;
    this.isPasswordMismatch = false;
    if (this.form.status == 'VALID') {
      if (this.form.value.password == this.form.value.repassword) {
        this.isLoader = true;
        if (this.userId && this.resetCode) {
          let input = {

            "userResetToken": this.userId,

          }
          this.resetPassword.verifyResetLink(input).subscribe({
            next: (res) => {
              if (res.Message == "Success" && res.StatusCode == 200) {
                this.updatePassword();

              }

            }
          });

        }

      } else {
        this.isPasswordMismatch = true;
      }
    }
  }



  updatePassword() {
    let passwordInput = {

      "userResetToken": this.userId,
      "resetCode": this.resetCode,
      "password": this.form.value.password

    }

    this.resetPassword.updatePassword(passwordInput).subscribe({
      next: (res) => {
        if (res.Message == "Password reset successfully." && res.StatusCode == 200) {
          this.toastService.toast('Password changed successfully', ToastType.Information);
          this.router.navigateByUrl('/signin');
        }

      }
    });


  }

}
